// Arrow-click scrolling for the process-view carousel. Touch/trackpad swipe
// already works with no JS at all (native CSS scroll-snap) — this only adds
// the desktop mouse-click affordance.
(function () {
  var track = document.getElementById('ProcessCarousel');
  if (!track) return;

  document.querySelectorAll('.process__carousel-arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var slide = track.querySelector('.process__slide');
      var amount = slide ? slide.getBoundingClientRect().width + 16 : 300;
      track.scrollBy({ left: amount * Number(btn.dataset.dir), behavior: 'smooth' });
    });
  });
})();
